import { KTIcon } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { UsersListFilter } from './UsersListFilter'

interface userListProps {
  label?: String
  secondLabel?: boolean
}

const UsersListToolbar = ({ label = '', secondLabel = false }: userListProps) => {
  const { setItemIdForUpdate, setSelectedLabel }: any = useListView()
  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {/* <UsersListFilter /> */}
      {/* <button type='button' className='btn btn-light-primary me-3'>
        <KTIcon iconName='exit-up' className='fs-2' />
        Export
      </button> */}
      {(label && (
        <button
          type='button'
          // style={{ backgroundColor: '#000000', color: "#FFE500" }}
          className='btn btn-primary'
          onClick={openAddUserModal}
        >
          <KTIcon iconName='plus' className='fs-2 text-white' />
          {label}
        </button>
      )) ||
        ''}
      {(secondLabel && (
        <button
          type='button'
          // style={{ backgroundColor: '#ED6E43'}}
          className='btn btn-primary ml-2'
          onClick={() => {
            setItemIdForUpdate(null)
            setSelectedLabel('second')
          }}
        >
          <KTIcon iconName='plus' className='fs-2' />
          Create Template
        </button>
      )) ||
        ''}
    </div>
  )
}

export { UsersListToolbar }
